import React, { useContext } from "react";
import { ProductContext } from "../../context/ProductContext";

const Header: React.FC = () => {
  const context = useContext(ProductContext);
  if (!context || !context.product) return null;

  const { headerLogo, headerLogoPosition } = context.product;

  // Map the position to Tailwind CSS classes
  const positionClass =
    headerLogoPosition === "center" ? "justify-center" :
    headerLogoPosition === "right" ? "justify-end" :
    "justify-start"; // Default is left

  return (
    <header className="shadow-sm py-4">
      <div className={`container mx-auto px-4 flex ${positionClass} items-center`}>
        {headerLogo && <img src={headerLogo} alt="Brand Logo" className="h-12" />}
      </div>
    </header>
  );
};

export default Header;